import React, { Component } from "react";
import PropTypes from "prop-types";
import { Tab } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Topology from "./Topology";
import GraphicTopology from "./GraphicTopology";
import Strings from "../utilities/StringSelector";

class TopologyWorkspace extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: this.getInitialActiveIndex(props)
    };
  }

  getInitialActiveIndex = (props) => {
    const routeState = props.location && props.location.state;
    return routeState && routeState.activeTabIndex === 1 ? 1 : 0;
  };

  handleTabChange = (event, data) => {
    this.setState({ activeIndex: data.activeIndex });
  };

  openGraphicTopology = (navigationState = {}) => {
    this.props.history.push({
      pathname: "/topology",
      state: {
        ...navigationState,
        activeTabIndex: 0
      }
    });

    this.setState({ activeIndex: 0 });
  };

  render() {
    const panes = [
      {
        menuItem: {
          key: "graphic-topology",
          icon: "object group outline",
          content: Strings.GRAPHIC_TOPOLOGY
        },
        render: () => (
          <Tab.Pane className="ts-topology-workspace-pane ts-topology-graphic-pane">
            <GraphicTopology />
          </Tab.Pane>
        )
      },
      {
        menuItem: {
          key: "network-topology",
          icon: "table",
          content: Strings.TABLE_TOPOLOGY
        },
        render: () => (
          <Tab.Pane className="ts-topology-workspace-pane ts-topology-table-pane">
            <Topology onOpenGraphicTopology={this.openGraphicTopology} />
          </Tab.Pane>
        )
      }
    ];

    return (
      <main className="ts-topology-workspace">
        <Tab
          className="ts-topology-workspace-tabs"
          panes={panes}
          activeIndex={this.state.activeIndex}
          onTabChange={this.handleTabChange}
          renderActiveOnly={true}
        />
      </main>
    );
  }
}

TopologyWorkspace.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.object
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

export default withRouter(TopologyWorkspace);